const apiUrl = process.env.REACT_APP_API_URL;

export const DeleteDocument = async (id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/documents/${id}`, {
            method: 'DELETE'
        });
        return response;
    } catch (error) {
        console.log('Error:', error);
    }
};
